<template>
  <header class="m-header">
    <div class="m-inner">
      <div class="m-brand" @click="goHome" role="button" tabindex="0" aria-label="返回首页">
        <img class="m-logo" src="https://obs.huahuaeco.com/common/ic_huahua_banner.png" alt="化化" />
        <!-- <span class="m-sub">装修服务生态电商平台</span> -->
      </div>
      <button class="m-menu" type="button" @click="toggle" aria-label="打开导航">
        <span class="m-menu-icon" aria-hidden="true">≡</span>
      </button>
    </div>

    <div v-show="open" class="m-overlay" @click.self="close" aria-hidden="false">
      <nav class="m-drawer" aria-label="移动端导航">
        <router-link class="m-link" to="/m" @click="close">首页</router-link>
        <div class="m-link-group" :class="{ active: isServiceRoute }">
          <div class="m-link m-group-title">服务与解决方案</div>
          <router-link class="m-link m-sub-link" to="/m/decorationServices" @click="close">装修服务</router-link>
          <router-link class="m-link m-sub-link" to="/m/selfBuildServices" @click="close">自建房服务</router-link>
        </div>
        <router-link class="m-link" to="/m/strategy/list" @click="close">攻略</router-link>
        <router-link class="m-link" to="/m/case" @click="close">案例</router-link>
        <router-link class="m-link" to="/m/settlein" @click="close">服务商入驻</router-link>
        <router-link class="m-link" to="/m/about" @click="close">关于我们</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader',
  data() {
    return { open: false }
  },
  computed: {
    isServiceRoute() {
      const path = this.$route?.path || ''
      return path.startsWith('/m/decorationServices')
        || path.startsWith('/m/selfBuildServices')
        || path.startsWith('/m/product')
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    close() {
      this.open = false
    },
    goHome() {
      this.close()
      this.$router.push('/m')
    }
  },
  watch: {
    $route() {
      this.close()
    }
  }
}
</script>

<style scoped>
.m-header{position:fixed;top:0;left:0;right:0;z-index:1000;background:rgba(255,255,255,0.95);backdrop-filter:blur(4px);border-bottom:1px solid rgba(14,165,233,0.06)}
.m-inner{height:calc(88 * var(--rpx));display:flex;align-items:center;justify-content:space-between;padding:0 calc(24 * var(--rpx))}
.m-brand{display:flex;align-items:center;gap:calc(12 * var(--rpx));min-width:0;cursor:pointer}
.m-logo{height:calc(65 * var(--rpx));display:block}
.m-sub{font-size:calc(24 * var(--rpx));color:#64748b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}

.m-menu{width:calc(72 * var(--rpx));height:calc(72 * var(--rpx));border:0;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center}
.m-menu-icon{font-size:calc(48 * var(--rpx));line-height:1;color:#64748b}

.m-overlay{position:fixed;left:0;right:0;bottom:0;top:calc(88 * var(--rpx));z-index:1100;background:transparent;}
.m-drawer{width:45%;height:auto;max-height:calc(100vh - 88 * var(--rpx) - 24 * var(--rpx));overflow-y:auto;background:#fff;box-shadow:calc(10 * var(--rpx)) 0 calc(34 * var(--rpx)) rgba(15, 23, 42, 0.16);border-bottom-right-radius:calc(18 * var(--rpx));padding:calc(16 * var(--rpx)) 0;}
.m-link{display:block;padding:calc(24 * var(--rpx)) calc(32 * var(--rpx));text-decoration:none;color:rgba(38, 38, 38, 1);font-size:calc(28 * var(--rpx));background-color: #fff;}
.m-link.router-link-active{color:#198CFE;background:#F4F7FB;font-weight: bold;position: relative;}
.m-link.router-link-active::before{content:"";position:absolute;left:0;top:50%;transform:translateY(-50%);width:calc(8 * var(--rpx));height:calc(32 * var(--rpx));background:#198CFE;border-radius:4px}
.m-link-group{background:#fff}
.m-group-title{color:#262626;font-weight:600;pointer-events:none}
.m-sub-link{padding-left:calc(56 * var(--rpx));font-size:calc(26 * var(--rpx));color:#595959}
.m-link-group.active .m-group-title{color:#198CFE;background:#F4F7FB;position:relative}
.m-link-group.active .m-group-title::before{content:"";position:absolute;left:0;top:50%;transform:translateY(-50%);width:calc(8 * var(--rpx));height:calc(32 * var(--rpx));background:#198CFE;border-radius:4px}
</style>
